import { TemaCard } from 'src/data/models/TemaCardModel';

export const workCards: TemaCard[] = [
    // 💡 Tipo de Hornea (Work Type)
    new TemaCard(
        'work35',
        'Work',
        'word',
        'trabajo a tiempo completo',
        'full-time work',
        'Standard work schedule.',
        [
            { spanish: 'trabajo a tiempo parcial', english: 'part-time work' },
            { spanish: 'trabajo temporal', english: 'temporary work' },
            { spanish: 'freelance', english: 'freelance' },
            { spanish: 'trabajo remoto', english: 'remote work' },
        ]
    ),
    new TemaCard(
        'work1',
        'Work',
        'phrase',
        'Estoy buscando trabajo.',
        'I am looking for a job.',
        'A basic phrase when networking or applying.'
    ),
    new TemaCard(
        'work2',
        'Work',
        'sentence',
        'Tengo experiencia en gestión de proyectos.',
        'I have experience in project management.',
        'Useful to describe your professional background.'
    ),
    new TemaCard(
        'work3',
        'Work',
        'phrase',
        '¿Cuáles son sus expectativas salariales?',
        'What are your salary expectations?',
        'Common interview question.'
    ),
    new TemaCard(
        'work4',
        'Work',
        'sentence',
        'Soy una persona proactiva y orientada a resultados.',
        'I’m a proactive, results-oriented person.',
        'Common soft-skill phrase for interviews.'
    ),
    new TemaCard(
        'work5',
        'Work',
        'sentence',
        '¿Qué tipo de horario tiene el trabajo?',
        'What is the work schedule like?',
        'Useful question during interviews.'
    ),
    new TemaCard(
        'work6',
        'Work',
        'phrase',
        '¿Cuáles son las oportunidades de crecimiento?',
        'What are the growth opportunities?',
        'Great question for interviews to gauge career advancement.'
    ),

    // 🧑‍💻 Office Vocabulary
    new TemaCard(
        'work7',
        'Work',
        'word',
        'reunión',
        'meeting',
        'Common office term.',
        [
            { spanish: 'agenda', english: 'agenda' },
            { spanish: 'minuta', english: 'meeting minutes' },
            { spanish: 'asistencia', english: 'attendance' },
            { spanish: 'presentación', english: 'presentation' },
            { spanish: 'discusión', english: 'discussion' },
            { spanish: 'informe', english: 'report' },
        ]
    ),
    new TemaCard(
        'work8',
        'Work',
        'word',
        'jefe',
        'boss',
        'Common hierarchy vocabulary.',
        [
            { spanish: 'compañero', english: 'coworker' },
            { spanish: 'equipo', english: 'team' },
            { spanish: 'subordinado', english: 'subordinate' },
            { spanish: 'gerente', english: 'manager' },
            { spanish: 'director', english: 'director' },
            { spanish: 'empleado', english: 'employee' },
            { spanish: 'coordinador', english: 'coordinator' },
            { spanish: 'presidente', english: 'president' },
        ]
    ),
    new TemaCard(
        'work9',
        'Work',
        'word',
        'oficina',
        'office',
        'Basic office-related vocabulary.',
        [
            { spanish: 'escritorio', english: 'desk' },
            { spanish: 'silla', english: 'chair' },
            { spanish: 'computadora', english: 'computer' },
            { spanish: 'archivo', english: 'file' },
            { spanish: 'reporte', english: 'report' },
            { spanish: 'impresora', english: 'printer' },
            { spanish: 'proyector', english: 'projector' },
        ]
    ),

    // 💻 Remote Work & Tech
    new TemaCard(
        'work10',
        'Work',
        'phrase',
        'Trabajo desde casa.',
        'I work from home.',
        'Common in remote job contexts.'
    ),
    new TemaCard(
        'work11',
        'Work',
        'sentence',
        'Tenemos una videollamada a las 10.',
        'We have a video call at 10.',
        'Used in remote work environments.'
    ),
    new TemaCard(
        'work12',
        'Work',
        'sentence',
        '¿Tienes acceso a Internet? ',
        'Do you have internet access?',
        'A common question in remote work.'
    ),
    new TemaCard(
        'work13',
        'Work',
        'phrase',
        '¿Podemos compartir la pantalla?',
        'Can we share the screen?',
        'Common phrase in video calls for collaboration.'
    ),

    // 📧 Email & Communication
    new TemaCard(
        'work14',
        'Work',
        'sentence',
        'Adjunto mi currículum para su consideración.',
        'I am attaching my resume for your consideration.',
        'Professional email sentence.'
    ),
    new TemaCard(
        'work15',
        'Work',
        'phrase',
        'Quedo atento a sus comentarios.',
        'I look forward to your feedback.',
        'Polite phrase to end formal emails.'
    ),
    new TemaCard(
        'work16',
        'Work',
        'phrase',
        'Gracias por su tiempo.',
        'Thank you for your time.',
        'Always a good closer in any setting.'
    ),
    new TemaCard(
        'work17',
        'Work',
        'sentence',
        'Espero tener noticias suyas pronto.',
        'I hope to hear from you soon.',
        'Common way to close job applications.'
    ),
    new TemaCard(
        'work18',
        'Work',
        'phrase',
        'Quedo a su disposición para cualquier pregunta.',
        'I am at your disposal for any questions.',
        'Polite phrase to express availability in emails.'
    ),

    // 🤝 Soft Skills & Workplace Behavior
    new TemaCard(
        'work19',
        'Work',
        'sentence',
        'Me adapto fácilmente a nuevos entornos.',
        'I adapt easily to new environments.',
        'Great soft-skill expression.'
    ),
    new TemaCard(
        'work20',
        'Work',
        'sentence',
        'Estoy dispuesto a aprender y mejorar constantemente.',
        'I am willing to learn and constantly improve.',
        'Good for interviews or performance reviews.'
    ),
    new TemaCard(
        'work21',
        'Work',
        'phrase',
        'Trabajo bien bajo presión.',
        'I work well under pressure.',
        'Useful phrase to express capability in high-pressure environments.'
    ),
    new TemaCard(
        'work22',
        'Work',
        'sentence',
        'Tengo excelentes habilidades de comunicación.',
        'I have excellent communication skills.',
        'A great statement to express communication abilities.'
    ),
    new TemaCard(
        'work23',
        'Work',
        'sentence',
        'Soy muy organizado/a.',
        'I am very organized.',
        'Useful when describing your personal attributes.'
    ),

    // 📅 Scheduling & Time Management
    new TemaCard(
        'work24',
        'Work',
        'phrase',
        '¿Cuándo es la fecha límite para este proyecto?',
        'What is the deadline for this project?',
        'Great for clarifying deadlines during work.'
    ),
    new TemaCard(
        'work25',
        'Work',
        'sentence',
        'Necesito un par de días para completar la tarea.',
        'I need a couple of days to complete the task.',
        'Useful to express time needed for tasks.'
    ),
    new TemaCard(
        'work26',
        'Work',
        'phrase',
        '¿Puedo tener más tiempo para esta tarea?',
        'Can I have more time for this task?',
        'Request for an extension when under time constraints.'
    ),
    new TemaCard(
        'work27',
        'Work',
        'sentence',
        'Este proyecto está a punto de terminar.',
        'This project is about to finish.',
        'Phrase to inform others of project status.'
    ),
    // 🏥 Healthcare Professions
    new TemaCard(
        'work28',
        'Work',
        'word',
        'médico/a',
        'doctor',
        'Profession in healthcare.',
        [
            { spanish: 'enfermero/a', english: 'nurse' },
            { spanish: 'veterinario/a', english: 'veterinarian' },
            { spanish: 'dentista', english: 'dentist' },
            { spanish: 'psicólogo/a', english: 'psychologist' },
        ]
    ),

    // 💼 Office & Business Professions
    new TemaCard(
        'work29',
        'Work',
        'word',
        'abogado/a',
        'lawyer',
        'Profession in legal fields.',
        [
            { spanish: 'contador/a', english: 'accountant' },
            { spanish: 'consultor/a', english: 'consultant' },
            { spanish: 'gerente', english: 'manager' },
            { spanish: 'administrador/a', english: 'administrator' },
        ]
    ),

    // 🏗️ Technical & Engineering Professions
    new TemaCard(
        'work30',
        'Work',
        'word',
        'ingeniero/a',
        'engineer',
        'Common technical profession.',
        [
            { spanish: 'arquitecto/a', english: 'architect' },
            { spanish: 'programador/a', english: 'programmer' },
            { spanish: 'electricista', english: 'electrician' },
            { spanish: 'mecánico/a', english: 'mechanic' },
        ]
    ),

    // 🍴 Culinary Professions
    new TemaCard(
        'work31',
        'Work',
        'word',
        'cocinero/a',
        'chef',
        'Profession in the culinary field.',
        [
            { spanish: 'pastelero/a', english: 'pastry chef' },
            { spanish: 'camarero/a', english: 'waiter/waitress' },
            { spanish: 'bartender', english: 'bartender' },
        ]
    ),

    // 🎨 Creative Professions
    new TemaCard(
        'work32',
        'Work',
        'word',
        'diseñador/a gráfico/a',
        'graphic designer',
        'Creative profession related to visual design.',
        [
            { spanish: 'artista', english: 'artist' },
            { spanish: 'fotógrafo/a', english: 'photographer' },
            { spanish: 'redactor/a', english: 'copywriter' },
            { spanish: 'modista', english: 'fashion designer' },
        ]
    ),

    // 🧑‍🏫 Educational Professions
    new TemaCard(
        'work33',
        'Work',
        'word',
        'profesor/a',
        'teacher',
        'Profession in education.',
        [
            { spanish: 'tutor/a', english: 'tutor' },
            { spanish: 'educador/a', english: 'educator' },
            { spanish: 'director/a', english: 'principal' },
            { spanish: 'maestro/a', english: 'school teacher' },
        ]
    ),

];
